
import gatblac from './companies/default/main.js'
import kia from './companies/kia/main.js'
import unibag from './companies/unibag/main.js'
import etienne from './companies/etienne/main.js'
import ccu from './companies/ccu/main.js'
import dbshop from './companies/dbshop/main.js'
import tua from './companies/tua/main.js'
import creditotal from './companies/creditotal/main.js'
import copelec from './companies/copelec/main.js'
import kross from './companies/kross/main.js'
import naturaloe from './companies/naturaloe/main.js'
import cacem from './companies/cacem/main.js'
import gatblacnew from './companies/gatblac/main.js'
import gbcourses from './companies/gbcourses/main.js'
import begiver from './companies/begiver/main.js'
import simpli from './companies/simpli/main.js'
import realme from './companies/realme/main.js'
import bkpostventa from './companies/bk/bkpostventa/main.js'
import bricsa from './companies/bricsa/main.js'
import mdsc from './companies/mdsc/main.js'
import gbTrialBlue from './companies/gb-trial/main-blue.js'
import gbTrialBlack from './companies/gb-trial/main-black.js'
import bsx from './companies/bsx/main.js'
import bci from './companies/bci/main.js'
import nuam from './companies/nuam/main.js'
import a2censo from './companies/a2censo/main.js'
import bvc from './companies/bvc/main.js'
import bvl from './companies/bvl/main.js'

/**
 * Obtiene CSS en función de compañía recibida
 * @param {String} company id de compañia.
 * @return {Object} CSS asociado a la compañia.
 */
const getCSS = function (company) {
  const companies = [
    gatblac.CSS,
    kia.CSS,
    copelec.CSS,
    creditotal.CSS,
    dbshop.CSS,
    tua.CSS,
    ccu.CSS,
    etienne.CSS,
    unibag.CSS,
    kross.CSS,
    naturaloe.CSS,
    cacem.CSS,
    gatblacnew.CSS,
    gbcourses.CSS,
    begiver.CSS,
    simpli.CSS,
    realme.CSS,
    bkpostventa.CSS,
    bricsa.CSS,
    mdsc.CSS,
    gbTrialBlue.CSS,
    gbTrialBlack.CSS,
    bsx.CSS,
    bci.CSS,
    nuam.CSS,
    a2censo.CSS,
    bvc.CSS,
    bvl.CSS
  ]

  return companies.find((c) => c.id === company) || companies[0]
}

/**
 * Obtiene Forms en función de compañía recibida
 * @param {String} company nombre de compañia.
 * @return {Object} Formularios asociados a la compañia.
*/
const getForms = function (company) {
  const companies = [
    {
      name: 'defaut',
      forms: gatblac.FORMS
    }, {
      name: 'kia',
      forms: kia.FORMS
    }, {
      name: 'tiendaCopelec',
      forms: copelec.FORMS
    }, {
      name: 'tua',
      forms: tua.FORMS
    }, {
      name: 'unibag',
      forms: unibag.FORMS
    }, {
      name: 'creditotal',
      forms: creditotal.FORMS
    }, {
      name: 'dbshop',
      forms: dbshop.FORMS
    }, {
      name: 'ccu',
      forms: ccu.FORMS
    },
    {
      name: 'etienne',
      forms: etienne.FORMS
    },
    {
      name: 'kross',
      forms: kross.FORMS
    },
    {
      name: 'naturaloe',
      forms: naturaloe.FORMS
    },
    {
      name: 'cacem',
      forms: cacem.FORMS
    },
    {
      name: 'gatblac-new',
      forms: gatblacnew.FORMS
    },
    {
      name: 'gb-courses',
      forms: gbcourses.FORMS
    },
    {
      name: 'begiver',
      forms: begiver.FORMS
    },
    {
      name: 'simpli',
      forms: simpli.FORMS
    },
    {
      name: 'realme',
      forms: realme.FORMS
    },
    {
      name: 'bkpostventa',
      forms: bkpostventa.FORMS
    },
    {
      name: 'bricsa',
      forms: bricsa.FORMS
    },
    {
      name: 'mdsc',
      forms: mdsc.FORMS
    },
    {
      name: 'gb-trial-blue',
      forms: gbTrialBlue.FORMS
    },
    {
      name: 'gb-trial-black',
      forms: gbTrialBlack.FORMS
    },
    {
      name: 'bsx',
      forms: bsx.FORMS
    },
    {
      name: 'bci',
      forms: bci.FORMS
    },
    {
      name: 'nuam',
      forms: nuam.FORMS
    },
    {
      name: 'a2censo',
      forms: a2censo.FORMS
    },
    {
      name: 'bvc',
      forms: bvc.FORMS
    },
    {
      name: 'bvl',
      forms: bvl.FORMS
    }
  ]

  return companies.find((c) => c.name === company) || companies[0]
}

export { getCSS, getForms }
